<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.value" class="input-with-select" size="small">
                        <el-select v-model="params.type" slot="prepend" placeholder="请选择">
                            <el-option label="用户ID" :value="1"></el-option>
                            <el-option label="用户名" :value="2"></el-option>
                            <el-option label="负责人手机" :value="3"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.provinceCode" placeholder="请选择省份" size="small" clearable filterable @change="getCityList">
                        <el-option v-for="(item,index) in province" :key="index" :value="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.cityCode" placeholder="请选择城市" clearable filterable size="small">
                        <el-option v-for="(item,index) in city" :key="index" :value="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.order" placeholder="请选择" size="small">
                        <el-option label="优先展示最新注册的" :value="1"></el-option>
                        <el-option label="优先展示最近登录的" :value="2"></el-option>
                    </el-select>
                </el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.douyinStatus" placeholder="请选择" size="small">
				        <el-option label="不限制是否绑定抖音 POI" value=""></el-option>
				        <el-option label="仅看未绑定的" :value="0"></el-option>
						<el-option label="仅看绑定中的" :value="1"></el-option>
						<el-option label="仅看绑定成功的" :value="2"></el-option>
						<el-option label="仅看绑定失败的" :value="3"></el-option>
				    </el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.meiTuanStatus" placeholder="请选择" size="small">
				        <el-option label="不限制是否绑定美团 POI" value=""></el-option>
				        <el-option label="仅看未绑定的" :value="0"></el-option>
						<el-option label="仅看绑定中的" :value="1"></el-option>
						<el-option label="仅看绑定成功的" :value="2"></el-option>
						<el-option label="仅看绑定失败的" :value="3"></el-option>
				    </el-select>
				</el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.seatStatus" placeholder="请选择" size="small">
				        <el-option label="不限制是否开启座位图" value=""></el-option>
				        <el-option label="仅看未开启的" :value="1"></el-option>
						<el-option label="仅看已开启的" :value="3"></el-option>
                        <el-option label="仅看开启中的" :value="2"></el-option>
                        <el-option label="仅看开启失败的" :value="4"></el-option>
				    </el-select>
				</el-col>
                <el-col :xs="24" :sm="12" :md="14" :lg="11" :xl="8">
                    <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                            <el-select v-model="params.timeType" slot="prepend" placeholder="请选择">
                                <el-option label="注册时间" :value="1"></el-option>
                                <el-option label="最近登录时间" :value="2"></el-option>
                            </el-select>
                        </el-input>
                        <el-date-picker
                            v-model="datetimerange"
                            type="datetimerange"
                            range-separator="-"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            class="fl"
                            size="small"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']"
                            unlink-panels
                            >
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div v-if="$utils.have('/site/save')" class="page-btns-box">
            <el-button type="primary" icon="el-icon-plus" size="small" @click="$refs.siteAdd.show()">创建场地</el-button>
			<el-button type="primary" icon="el-icon-collection-tag" size="small"  @click="batchPushMeituan" >批量匹配美团 POI</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="status" label="账号状态">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status == 1" type="success" size="mini">正常</el-tag>
                        <el-tag v-else type="info" size="mini">注销</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="ID"></el-table-column>
                <el-table-column prop="name" label="用户名" min-width="120">
                    <template slot-scope="scope">
                        <el-tooltip placement="top">
                            <div slot="content" class="avatar">
                                <el-image v-if="scope.row.avatar" :src="scope.row.avatar"></el-image>
                                <p>{{scope.row.name}}</p>
                            </div>
                            <div class="ellipsis">{{scope.row.name}}</div>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="telephone" label="负责人手机" min-width="110">
                    <template slot-scope="scope">
                        {{scope.row.telephone && scope.row.telephone.includes('tmp') ? '' : scope.row.telephone}}
                    </template>
                </el-table-column>
                <el-table-column prop="provinceName" label="省份"></el-table-column>
                <el-table-column prop="cityName" label="城市"></el-table-column>
                <el-table-column prop="registTime" label="注册时间" min-width="150"></el-table-column>
                <el-table-column prop="lastLoginTime" label="最近登录时间" min-width="150"></el-table-column>				
				<el-table-column prop="douyinStatus" label="绑定抖音 POI状态" min-width="150">
					<template slot-scope="scope">						
						<el-link
						    v-if="scope.row.douyinStatus == 2 && scope.row.douyinSitePoiId"
						    type="primary"
						    size="small"
						    icon="el-icon-link"
						    :href="`https://aweme.snssdk.com/falcon/poi_mwa/poi_detail?poi_id=${scope.row.douyinSitePoiId}`"
						    target="_blank"
							class="MR10"
						    >{{douyinStatus.get(scope.row.douyinStatus)}}</el-link
						>
						<span v-else>{{douyinStatus.get(scope.row.douyinStatus)}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="douyinStatus" label="绑定美团 POI状态" min-width="150">
					<template slot-scope="scope">						
						{{douyinStatus.get(scope.row.meiTuanStatus)}}
					</template>
				</el-table-column>
				<el-table-column prop="douyinBindTime" label="绑定时间" min-width="150"></el-table-column>
                <el-table-column label="操作" width="320">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/site/detail')"
                            type="text"
                            size="small"
                            icon="el-icon-view"
                            @click="edit(scope.row.id)"
                            >管理</el-button
                        >
                        <el-button
                            v-if="$utils.have('/userPunish/search') && scope.row.status == 1"
                            type="text"
                            size="small"
                            icon="el-icon-remove-outline"
                            @click="del(scope.row.id)"
                            >注销</el-button
                        >
                        <el-link
                            v-if="scope.row.status == 1"
                            type="primary"
                            size="small"
                            icon="el-icon-link"
                            :href="`${ssfb}/login/auto?id=${scope.row.encryptId}&token=${$store.state.CUSUT}`"
                            target="_blank"
							class="MR10"
                            >进入经营平台</el-link
						>
							
						<el-button
							v-if="$utils.have('/userPunish/search') && ( scope.row.douyinStatus == 0 || scope.row.douyinStatus == 3 )"
							type="text"
							size="small"
							icon="el-icon-thumb"
							@click="bindDouyin(scope.row.id,scope.row.name)"
							>绑定抖音</el-button
						>
						
                    </template>
                </el-table-column>
            </el-table>
        </div>        
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>

        <site-add ref="siteAdd" @onUpdate="getDataList()"></site-add>
		<push-meituan ref="PushMeituan"></push-meituan>
    </div>
</template>

<script>
import {fetchProvince,fetchCityList} from '@/assets/js/commonApi'
import SiteAdd from '@/components/SiteAdd';
import PushMeituan from './components/push-meituan';
const defaultParams = {
    pageNo:1,
    type: 2,
    value: '',
    timeType:1,
    startTime:'',
    endTime:'',
    provinceCode: '',
    cityCode: '',
    order: 1,
	douyinStatus:'',
	meiTuanStatus:'',
    seatStatus: ''
}
export default {
    components:{SiteAdd,PushMeituan},
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo:parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                type: parseInt(this.$route.query.type || 2),
                value: this.$route.query.value || '',
                timeType:parseInt(this.$route.query.timeType || 1),
                startTime:this.$route.query.startTime || '',
                endTime:this.$route.query.endTime || '',
                provinceCode: this.$route.query.provinceCode ? parseInt(this.$route.query.provinceCode) : '',
                cityCode: this.$route.query.cityCode ? parseInt(this.$route.query.cityCode) : '',
				douyinStatus: this.$route.query.douyinStatus ? parseInt(this.$route.query.douyinStatus) : '',
				meiTuanStatus: parseInt(this.$route.query.meiTuanStatus) || '',
                order: parseInt(this.$route.query.order || 1),
                seatStatus: this.$route.query.seatStatus ? parseInt(this.$route.query.seatStatus) : '',
            },
            listLoading: false,    
            datetimerange:[this.$route.query.startTime || '' , this.$route.query.endTime || ''],
            province:[],
            city:[],
            ssfb:process.env.VUE_APP_SSFB_URL
        }
    },
	computed:{
	    douyinStatus(){
	        return new Map([
				[0,'未绑定'],
	            [1,'绑定中'],
	            [2,'绑定成功'],
	            [3,'绑定失败'],
	        ])
	    }
	},
    created(){
        this.getProvince();
        if( this.params.provinceCode ){
            this.getCityList(this.params.cityCode);
        }
    },
    mounted(){
        this.getDataList();
    },
    methods:{
        //获取所有省份
        async getProvince(){
            const res = await fetchProvince({}).catch(() => {});
            const{ state, result} = res.data;
            if( state == 1 ){
                this.province = result;
            }
        },
        //获取城市
        async getCityList(cityCode){
            const res = await fetchCityList(this.params.provinceCode).catch(() => {});
            const{ state, result} = res.data;
            if( state == 1 ){
                this.city = result;
            }
            this.params.cityCode = cityCode || '';
        },
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.params = {
                ...this.params,
                startTime:this.datetimerange && this.datetimerange[0] || '',
                endTime:this.datetimerange && this.datetimerange[1] || ''
            }
            this.$request({
                url: "/site/list",
                method: "POST",
                data: this.params,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //注销
        del(id){
            this.$confirm('小站注销后前端不会展示,但是不影响用户购买的订单', '提示', {
                type: 'warning',
                center: true,
                confirmButtonText:'前往注销',
                cancelButtonText:'暂不注销',
                closeOnClickModal: false
            }).then(() => {
                this.$router.push({
                    path:'/user/punish/list',
                    query:{id:id}
                })
            }).catch(() => {})
        },		
		bindDouyin(id,name){
			var that = this
		    that.$confirm('确定要绑定场地: ' +name+ '到抖音POI吗？一旦操作不可撤销!', '提示', {
		        type: 'warning',
		        center: true,
		        confirmButtonText:'确定',
		        cancelButtonText:'取消',
		        closeOnClickModal: false
		    }).then( () => {
		        that.$request({
		            url: '/site/bindDouyin',
		            method: 'POST',
		            params: {id:id},
		        }).then(res=> {
		            let { state, msg } = res.data;
		            if (state == 1) {
		                that.$message.success("操作成功");
		                that.getDataList();
		            }else{
		                that.$message.error(msg || "请求失败");
		            }
		        })
		    })
		},
		batchPushMeituan(){
			this.$refs.PushMeituan.show()
		},
        //编辑、查看详情
        edit(id){
            this.$router.push({
                path: `/user/site/edit/baseInfo/${id}`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                },
            });
        }
    }
}
</script>


<style lang="scss" scoped>
.el-table{
    .el-link{
        font-size: 12px;
        margin-left:10px;
    }
}
.avatar{
    text-align: center;
    .el-image{
        width: 100px;
        margin-bottom: 10px;
    }
}
</style>